<template>
    <div>
        <Resultados/>
    </div>
</template>
<script>

import Resultados from '@/components/zzHalloween/Resultados'
export default {
    name: 'SolimanologMostrarResultados',
    components:{
        Resultados
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>